/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Pilot_Ready_Preview_LabelInputs */



/**
* | output |
* | --- |
* | "In Wundo" |
*
* @param {Onboarding_Pilot_Ready_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_pilot_ready_preview_label = /** @type {((inputs?: Onboarding_Pilot_Ready_Preview_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Pilot_Ready_Preview_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("In Wundo")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dans Wundo")
	return /** @type {LocalizedString} */ ("In Wundo")
});